import {createStyles, Theme} from "@material-ui/core";
import {styleColors, typography} from "src/main.style";

export const childinfoStyle = (theme: Theme) => createStyles({
  root: {
    padding: theme.spacing(3.25, 2.5, 2.5),

    '& > *': {
      boxSizing: 'border-box',
    }
  },
  kidsList: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',
    flexFlow: 'wrap',
    paddingBottom: 100,
    gap: theme.spacing(3.75),
    position: 'relative',
  },
  card: {
    display: 'flex',
    padding: theme.spacing(3.25, 2.5, 2.5),
    flexDirection: 'column',
    gap: theme.spacing(2),
    boxShadow: theme.shadows[4],
    borderRadius: '14px',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    width: '100%',
    minWidth: '320px',
    maxWidth: '420px',
    position: 'relative',
    border: `1px solid ${styleColors.blackAlpha23}`,
    transition: 'all 0.5s',
    zIndex: 1,
    ...(theme.palette.type === 'dark' ? {
      '& input::placeholder, & textarea::placeholder': {color: styleColors.greyDark1},
    } : {}),
  },
  cardTop: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    alignSelf: 'stretch',
  },
  name: {
    flex: 1,
    color: theme.palette.common.black,
    borderWidth: 0,
    outlineWidth: 0,
    padding: '0px',
    ...typography.input,
    fontSize: '1.125rem',
    minWidth: '150px'
  },
  topMiddle: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1,
  },
  saveButtonHidden: {
    alignSelf: 'flex-end',
    marginTop: '0px',
    maxHeight: '0px',
    overflow: 'hidden',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'all 0.3s',
  },
  saveButton: {
    alignSelf: 'flex-end',
    marginTop: '10px',
    maxHeight: '46px',
    overflow: 'hidden',
    opacity: 1,
    transition: 'all 0.3s',
  },
  title: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  row: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    width:'100%',
    maxWidth:'100%',
    gap: theme.spacing(1),
  },
  label: {
    ...typography.label,
    whiteSpace: 'nowrap',
    color: styleColors.greyDark1,
    fontWeight: 400,
    
  },
  vaccineBox : {
    backgroundColor: styleColors.greyLight1,
    padding: '10px',
    borderRadius: '5px',
    border: `1px solid ${styleColors.greyLight2}`,
  },
  passBox: {
    backgroundColor: styleColors.greyLight2,
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    borderRadius: '10px',
    marginBottom: '10px',
  },
  passLocation: {
    fontSize: '20px',
    marginTop: '6px',
  },
  passDate: {
    fontSize: '14px',
    fontWeight: 600,
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
  },
  vaccineGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    fontWeight: 600,
  },
  vaccineEditButton: {
    minHeight: '44px',
  },
  value: {
    ...typography.input,
    alignSelf: 'center',
    display: 'flex',
    textAlign: 'right',
    borderWidth: 0,
    backgroundColor: 'transparent',
    resize: 'none',
    maxWidth: '130px',
    color:styleColors.black,
    minWidth: '100px',
  },
});



// WEBPACK FOOTER //
// ./src/components/childinfo/childinfo.style.ts